<template>
	<el-drawer title="变更宠物" :visible.sync="visible" @close='comStateClose' size="600px" :close-on-press-escape="false"
		id="comDrawer" :modal-append-to-body="false">
		<div class="drawerView">
			<div class="drawerViewT">
				<div class="drawerCom">
					<div class="drawerComL">芯片编号：</div>
					<div class="drawerComR">
						<el-input v-model="epromNo" placeholder="请输入芯片编号" style="width: 224px;"></el-input>
					</div>
				</div>
				<div class="drawerCom">
					<div class="drawerComL">脖圈编号：</div>
					<div class="drawerComR">
						<el-input v-model="insideNo" placeholder="请输入脖圈编号" style="width: 224px;"></el-input>
					</div>
				</div>
				<div class="drawerCom" style="align-items: initial;">
					<div class="drawerComL">更换说明：</div>
					<div class="drawerComR">
						<el-input type="textarea" resize="none" rows="4" v-model="reason" placeholder="请输入更换说明" style="width: 300px;"></el-input>
					</div>
				</div>
			</div>
			<div class="drawerViewB">
				<div class="btn2" @click="comStateClose">取消</div>
				<div class="btn" @click="handleSunmitClick">确定</div>
			</div>
		</div>

	</el-drawer>
</template>

<script>
	export default {
		props: {
			comState: { //显示状态
				default: false
			},
			orderNo: {
				default: ''
			}
		},
		watch: {
			// 监视状态发生改变
			comState() {
				this.visible = this.comState;
			},
		},
		data() {
			return {
				visible: true,
				epromNo:'',
				insideNo:'',
				reason:'',
			}
		},
		mounted() {
			console.log(this.orderNo)
		},
		methods: {
			//提交
			handleSunmitClick(){
				if(this.insideNo == ''){
					this.$message({
						type: 'error',
						message: '请输入芯片编号'
					});
					return
				}
				if(this.epromNo == ''){
					this.$message({
						type: 'error',
						message: '请输入脖圈编号'
					});
					return
				}
				if(this.reason == ''){
					this.$message({
						type: 'error',
						message: '请输入变更原因'
					});
					return
				}
				let params = {
					orderNo:this.orderNo,
					insideNo:this.insideNo,
					epromNo:this.epromNo,
					reason:this.reason
				}
				console.log(params)
				this.$http.post(process.env.VUE_APP_AppAdmin + '/api/Logistics/update/pet/info', params).then((res) => {
					if (res.code == 0) {
						console.log(res.data)
						this.$message({
							type: 'none',
							message: '已变更'
						});
						this.$emit("closeOn", {type:'submit'});
					}
				})
			},
			//向父组件发射关闭弹框
			comStateClose() {
				this.$emit("closeOn", {type:'close'});
			},
		},
	}
</script>

<style scoped lang="scss">
	#comDrawer {
		::v-deep .el-drawer__header {
			padding: 20px;
			margin-bottom: 0;
		}

		::v-deep .el-drawer__body {
			height: calc(100% - 65px);
			overflow-y: auto;
		}
	}

	.drawerView {
		height: 100%;
		display: flex;
		flex-direction: column;
		.drawerViewT {
			flex: 1;
			box-sizing: border-box;
			border-top: solid 1px #F2F2F2;
			overflow-y: scroll;
			.drawerCom{
				display: flex;
				margin-top: 32px;
				align-items: center;
				.drawerComL{
					width: 132px;
					margin-right: 22px;
					font-size: 14px;
					color: #343440;
					text-align: right;
					line-height: 20px;
				}
				.drawerComR{
					flex: 1;
					font-size: 14px;
					
					.drawerSelect{
						display: flex;
						flex: 1;
						flex-wrap: wrap;
						.drawerSelectItem{
							width: 128px;
							height: 44px;
							box-sizing: border-box;
							font-size: 14px;
							color: #69697B;
							text-align: center;
							line-height: 44px;
							position: relative;
							background: #FAFAFD;
							border-radius: 8px;
							margin-right: 16px;
							margin-bottom: 10px;
							div:nth-of-type(1){
								position: absolute;
								left: 16px;
								top: 0;
								bottom: 0;
								margin: auto 0;
								width: 16px;
								height: 16px;
								border-radius: 100%;
								border: solid 1px #B0B0BF;
							}
						}
						.drawerSelectActiveItem{
							width: 128px;
							height: 44px;
							box-sizing: border-box;
							font-size: 14px;
							color: #577BFF;
							text-align: center;
							line-height: 44px;
							position: relative;
							background: #FAFAFD;
							border-radius: 8px;
							margin-right: 16px;
							margin-bottom: 10px;
							border: 1px solid #577BFF;
							div:nth-of-type(1){
								position: absolute;
								left: 16px;
								top: 0;
								bottom: 0;
								margin: auto 0;
								width: 4px;
								height: 4px;
								border-radius: 100%;
								border: solid 6px #577BFF;
							}
						}
						
					}
				}
			}
		}

		.drawerViewT::-webkit-scrollbar {
			display: none;
		}

		.drawerViewB {
			height: 60px;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			padding: 0 20px;
			border-top: solid 1px #F2F2F2;
			box-sizing: border-box;

			.btn {
				width: 98px;
				line-height: 40px;
				text-align: center;
				background: linear-gradient(135deg, #5685FF 0%, #3569FF 100%);
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				color: #fff;
				cursor: pointer;
				margin-left: 20px;
			}

			.btn2 {
				width: 98px;
				line-height: 40px;
				text-align: center;
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				cursor: pointer;
				box-sizing: border-box;
				border: solid 1px #577BFF;
				color: #577BFF;
			}
		}
	}
</style>
